import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ElementRef
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { SwalComponent } from '@toverux/ngx-sweetalert2';

import { ScriptLoaderService, SharedService, ClassService, AuthService } from '../_services';
import { AlertService, AlertComponent } from '../shared/alert';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './templates/login-1.component.html',
    styleUrls: ['./auth.component.scss']
})

export class AuthComponent implements OnInit {
    model: any = {};
    loading = false;
    returnUrl: string;
    animationClass: string = "flipInX";
    currentClass: string = "m-login--signin";
    endSessionMsg: string = 'Se terminó la sesión';
    @ViewChild('errorSwal') private errorSwal: SwalComponent;
    @ViewChild('alertSignin',
        { read: ViewContainerRef }) alertSignin: ViewContainerRef;
    @ViewChild('alertSignup',
        { read: ViewContainerRef }) alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass',
        { read: ViewContainerRef }) alertForgotPass: ViewContainerRef;
    @ViewChild('forgotPassForm') forgotPassForm: ElementRef;
    @ViewChild('signInForm') signInForm: ElementRef;
    constructor(
        private _router: Router,
        private _script: ScriptLoaderService,
        private _auth: AuthService,
        private _route: ActivatedRoute,
        private _alertService: AlertService,
        private cfr: ComponentFactoryResolver,
        private _sharedService: SharedService,
        private _classService: ClassService
    ) {
    }
    private decodeError(error: any): string {
        if (!error.error) return error;
        let err = error.error.error;
        let func = function(keys: string[], object: any) {
            let out: string = "";
            keys.forEach(function(key: string) {
                object[key].forEach(function(message: string) {
                    out = out.concat(message.concat(" "));
                });
            });
            return out;
        }
        let errorMessage: string = (err) ?
            ('errors' in err) ? (func(Object.keys(err.errors), err.errors)) : err.message
            : error.message;
        return errorMessage;
    }
    animate(elem: any, animationClass: string, timeoutMs: number) {
        let cs = this._classService;
        cs.addClass(elem, 'animated ' + animationClass);
        setTimeout(() => {
            cs.removeClass(elem, 'animated ' + animationClass);
        }, timeoutMs);
    }
    ngOnInit() {
        this.model.remember = true;
        // get return url from route parameters or default to '/'
        this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
        this._router.navigate([this.returnUrl]);

        this._script.loadScripts('body', [
            'assets/vendors/base/vendors.bundle.js',
            'assets/demo/demo2/base/scripts.bundle.js'], true).then(() => {
                this._sharedService.emitLoad(false);
            });
        this._sharedService.unauthorizedEmitted$.subscribe(() => {
            this.errorSwal.show();
        });
    }
    showForm(form: any, classStr: string) {
        this.currentClass = classStr;
        this.animate(form, 'flipInX', 750);
        return false;
    }

    signin(form: any) {
        if (!form.valid) return false;
        this.loading = true;
        let formData = new FormData();
        formData.append('email', this.model.email);
        formData.append('password', this.model.password);
        this._auth.login(formData).subscribe(
            data => {
                // login successful if there's a jwt token in the response
                let user = data;
                if (user && (user as any).token) {
                    // store user details and jwt token in local storage to keep user logged in between page refreshes
                    localStorage.setItem('currentUser', JSON.stringify(user));
                }
                let currentUser = JSON.parse(localStorage.getItem('currentUser'));
                this._router.navigate([this.returnUrl]);
            },
            error => {
                this.showAlert('alertSignin');
                this._alertService.error(this.decodeError(error));
                this.loading = false;
            });
    }

    signup(form: any) {
        if (!form.valid) return false;
        this.loading = true;
        let formData = new FormData();
        formData.append('name', this.model.name);
        formData.append('email', this.model.email);
        formData.append('password', this.model.password);
        this._auth.signup(formData).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    'Thank you. To complete your registration please check your email.',
                    true);
                this.loading = false;
                this.showForm(this.signInForm.nativeElement, 'm-login--signin');
                this.model = {};
            },
            error => {
                this.showAlert('alertSignup');
                this._alertService.error(this.decodeError(error));
                this.loading = false;
            });
    }

    forgotPass(form: any) {
        if (!form.valid) return false;
        this.loading = true;
        let formData = new FormData();
        formData.append('email', this.model.email);
        this._auth.recovery(formData).subscribe(
            data => {
                this.showAlert('alertSignin');
                this._alertService.success(
                    data['message'],
                    true);
                this.loading = false;
                this.showForm(this.signInForm.nativeElement, 'm-login--signin');
                this.model = {};
            },
            error => {
                this.showAlert('alertForgotPass');
                if (error.error.message) {
                    this._alertService.error(this.decodeError(error.error.message));
                } else {
                    this._alertService.error(this.decodeError(error));
                }
                this.loading = false;
            });
    }

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/auth/auth.component.ts